export const FLOORS_PER_PAGE = 10;

export const getFloorPageCount = (floorCount: number) => {
  return Math.ceil(floorCount / FLOORS_PER_PAGE);
};

/**
 * The page a floor is on. The list grows upwards from the trigger, so page 0 holds the lowest floors even though
 * the floors are listed from highest to lowest.
 */
export const getFloorPageIndex = (floorIdsHighToLow: string[], floorId: string | null) => {
  const floorIndex = floorId ? floorIdsHighToLow.indexOf(floorId) : -1;
  if (floorIndex === -1) return 0;

  return getFloorPageCount(floorIdsHighToLow.length) - 1 - Math.floor(floorIndex / FLOORS_PER_PAGE);
};

/** How many pages to slide the list down to show a page. The top page only slides as far as its floors reach. */
export const getFloorListOffset = (pageIndex: number, floorCount: number) => {
  const remainder = floorCount % FLOORS_PER_PAGE;
  const isTopPage = pageIndex === getFloorPageCount(floorCount) - 1;

  if (pageIndex === 0) return 0;
  if (isTopPage && remainder > 0) return pageIndex - 1 + remainder / FLOORS_PER_PAGE;

  return pageIndex;
};
